module.exports = __webpack_public_path__ + "static/media/admin_canvas_placket_icon.35e28f15.svg";